import React from 'react'
import {
  CardModalView,
} from 'components/Sidebar'
import { FormattedMessage } from 'react-intl'
import BoardUsers from 'routes/Board/Users'

const TypedBoardUsers: any = BoardUsers

type Props = {
  onSelect: (userId: number) => void
}

const SelectUser: React.FC<Props> = ({
  onSelect,
}) => {
  return (
    <CardModalView
      title={<FormattedMessage id='BLOCKERS_CARD_BLOCK_USER_SELECT' />}
    >
      <TypedBoardUsers
        showPermissionGroups={false}
        showAsList
        getUserProps={(user) => {
          return {
            defaultMenu: false,
            onClick: () => {
              onSelect(user.id)
            },
          }
        }}
      />
    </CardModalView>
  )
}

export default SelectUser
